/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Step3Inputs */

const en_dr_room_step3 = /** @type {(inputs: Dr_Room_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assumptions`)
};

const id_dr_room_step3 = /** @type {(inputs: Dr_Room_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asumsi`)
};

/**
* | output |
* | --- |
* | "Assumptions" |
*
* @param {Dr_Room_Step3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_step3 = /** @type {((inputs?: Dr_Room_Step3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Step3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_step3(inputs)
	return en_dr_room_step3(inputs)
});